export enum PossibleTranslationsEnum {
  PL = 'pl',
  EN = 'en',
  DE = 'de'
}
